<mat-toolbar>
	<button *ngIf="!options?.hideBackButton" mat-icon-button>
		<span class="ico-arrow-back" (click)="goBack()"></span>
	</button>
	<div class="title">
		<span *ngIf="titleText; else logo" [innerHtml]="titleText | translate"></span>
		<ng-template #logo>
			<a (click)="dispatchUiInteraction(logoTrackingData)" [obgRouteLink]="homeRoute" test-id="navbar-logo">
				<img obgImageContent="general.left-menu-brand-logo" />
			</a>
		</ng-template>
	</div>
	<span *ngIf="options?.showCloseButton" class="ico-close" (click)="goBack()"></span>
</mat-toolbar>
